import { Select } from "antd";
import { DefaultOptionType } from "antd/es/select";
import styles from "./index.module.css";
import { CSSProperties } from "react";
import checked from "assets/svg/CheckRegular.svg";
import x from "assets/svg/X.svg";

export type PropsSelectData = {
  placeHolder?: string;
  onChange: (value: string[]) => void;
  options: DefaultOptionType[];
  style?: CSSProperties;
  value: string[];
  isLoadingSelect: boolean;
  suffixIcon?: React.ReactNode;
  allHeight?: boolean;
};

export const SelectData = ({
  onChange,
  options,
  placeHolder,
  style,
  value,
  isLoadingSelect,
  suffixIcon,
  allHeight,
}: PropsSelectData) => {
  return (
    <Select
      maxTagCount={1}
      maxLength={2}
      maxTagPlaceholder={`${value.length - 1}+`}
      loading={isLoadingSelect}
      mode="multiple"
      style={style}
      value={value}
      className={styles.selectData}
      options={options}
      popupClassName={`${styles.dropDown} ${allHeight ? styles.allHieght : ""}`}
      size="small"
      allowClear={false}
      onChange={onChange}
      placeholder={placeHolder}
      suffixIcon={suffixIcon ? suffixIcon : <div className={styles.showIcon} />}
      menuItemSelectedIcon={<img src={checked} alt="checked" />}
      removeIcon={<img src={x} alt="remove" className={styles.removalBtn} />}
    />
  );
};
